var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-row",class:{border:_vm.showBorder}},[_c('div',{staticClass:"text-row__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-row__content",class:{edit:_vm.isEdit}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }